import { ApolloQueryResult, OperationVariables } from '@apollo/client'
import { IconButton } from '@material-ui/core'
import RefreshIcon from '@material-ui/icons/Refresh'

import { getTranslate } from '../../localization'
import { PushDetails } from '../../types/channelPush'
import useStyles from './styles/adaptorsTableHead.styles'

interface AdaptorsTableHeadProps {
  refetch: (variables?: Partial<OperationVariables> | undefined) => Promise<
    ApolloQueryResult<{
      channelPush: PushDetails
    }>
  >
}

const AdaptorsTableHead: React.FC<AdaptorsTableHeadProps> = ({ refetch }) => {
  const classes = useStyles()

  return (
    <div className={classes.tableHead}>
      <div>{getTranslate('Adaptor')}</div>
      <div>{getTranslate('Interval (s)')}</div>
      <div>{getTranslate('State')}</div>
      <div>{getTranslate('Last Attempt')}</div>
      <div>{getTranslate('Failure Count')}</div>
      <div>{getTranslate('Endpoint')}</div>
      <div>
        <IconButton onClick={() => refetch()}>
          <RefreshIcon />
        </IconButton>
      </div>
    </div>
  )
}

export default AdaptorsTableHead
